<template>
  <div class="content">
    <div class="container intro">
      <div class="flex">
        <div class="main well" v-if="this.isMobile">
          <a-row :gutter="50" class="pt-10">
            <a-col :sm="24">
              <h1>Aan de slag</h1>
              <p>Deze website is niet beschikbaar op mobiel.</p>
            </a-col>
          </a-row>
        </div>
        <div class="main" v-if="!this.isMobile && this.isSupportedBrowser">
          <a-row :gutter="50">
            <a-col :sm="24">
              <h1>{{ title }}</h1>
              <p>{{ text }}</p>
            </a-col>
          </a-row>
          <a-row :gutter="50">
            <a-col :sm="24">
              <h2>Hoe gaat u gegevens aanleveren?</h2>
              <p>{{ dataProvideText }}</p>
            </a-col>
            <a-col :sm="12" :md="12" :lg="getViews(data).length > 1 ? 12 : 24"
                   v-for="(view,idx) in getViews(data)" :key="idx"
            >
              <div class="manual" v-if="view.text_1" :style="viewStyle(view)">
                <div :class="getViews(data).length > 1 ? 'desc' : ''">
                  <h3 :style="fontStyle(view)">{{ view.title }}</h3>
                  <p :style="fontStyle(view)">Klik op de onderstaande button om te starten.</p>
                  <a-button
                      :class="view.buttonClass"
                      :loading="data.status.loading"
                      size="large"
                      type="primary"
                      @click="next(view.route)"
                  >
                    {{view.buttonText}}
                  </a-button>
                  <p :style="fontStyle(view)">{{ view.text_1 }}</p>
                  <p :style="fontStyle(view)">{{ view.text_2 }}</p>
                  <p :style="fontStyle(view)">{{ view.text_3 }}</p>
                </div>
              </div>
            </a-col>
          </a-row>
          <a-row class="pt-20" :gutter="50">
            <a-col :sm="12" :md="12" :lg="getViews(data).length > 1 ? 12 : 24"
                   v-for="(view,idx) in getViews(data)" :key="idx"
            >
              <div v-if="!view.text_1" :class="getViews(data).length > 1 ? 'cta' : ''">
                <a-button
                    :class="view.buttonClass"
                    :loading="data.status.loading"
                    size="large"
                    type="primary"
                    @click="next(view.route)"
                >
                  {{view.buttonText}}
                </a-button>
              </div>
            </a-col>
          </a-row>
        </div>
        <div class="sidebar">
          <side-nav step="intro" :loading="data.status.loading"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getDataProvideText,
  getIntro,
  getInvitationName,
  getInvitationText,
  getSupportedBrowsers,
  isMobile,
  isSupportedBrowser,
  LOGOUT,
  router
} from '../../../helpers'
import { mapActions } from 'vuex'
import SideNav from '../../../components/SideNav/SideNav'

export default {
  name: 'debug-intro',
  components: { SideNav },
  computed: {
    data () {
      return this.$store.state.survey
    }
  },
  data () {
    return {
      invitationType: this.$route.query.invitationType,
      title: getInvitationName(this.$route.query.invitationType),
      text: getInvitationText(this.$route.query.invitationType),
      dataProvideText: getDataProvideText(this.$route.query.invitationType),
      isMobile: isMobile(),
      browsers: getSupportedBrowsers(),
      isSupportedBrowser: isSupportedBrowser()
    }
  },
  mounted: function () {
    if (isSupportedBrowser()) {
      this.setCustomer(this.invitationType)
      this.getHDNCompanies()
      this.getHDNCompanyLabels()
    }
  },
  methods: {
    ...mapActions('survey', ['setCustomer', 'getHDNCompanies', 'getHDNCompanyLabels']),
    ...mapActions('auth', ['logout']),
    onLoad (e) {
      if (isSupportedBrowser()) {
        this.setCustomer(this.invitationType)
      }
    },
    getBrowser (browser) {
      const win = window.open(browser.url, '_blank')
      win.focus()
    },
    getViews (data) {
      return getIntro(data.style, data.customer.has_partner.value, data.customer.invitation)
    },
    next (route) {
      if (route === LOGOUT) {
        this.logout({ redirect: '/login' })
      } else {
        router.push(route)
      }
    },
    viewStyle (view) {
      return {
        color: view.color,
        backgroundColor: view.backgroundColor
      }
    },
    fontStyle (view) {
      return {
        color: view.color
      }
    }
  }
}
</script>
